<template>
    <blockquote class="quote">
        <div class="quote__content">
            <!-- eslint-disable-next-line vue/no-v-html -->
            <div v-html="autop(content)"></div>
        </div>

        <footer>
            <cite class="quote__author">
                {{ author }}
            </cite>
        </footer>
    </blockquote>
</template>

<script>
    import { autop } from '@wordpress/autop'
    export default {
        props: {
            content: { type: String, required: true },
            author: { type: String, required: true },
        },

        methods: {
            autop,
        },
    }
</script>
